import { Button, Icon } from "@legal-500/legal500-design-system";
import styles from "./MailingGroups.module.css";

type Props = {
  count: number;
  // e.g. "· all matching, 3 excluded" or "· hand-picked".
  subtext: string;
  // When provided (explicit/hand-picked mode), renders a "View selected" button
  // so the operator can review/remove picks not visible under the current filter.
  onView?: () => void;
  onClear: () => void;
  onCreate: () => void;
};

// Sticky bar pinned to the bottom of the Candidates panel while a selection is
// active. It carries the "Create send" affordance so the operator confirms the
// audience (label/schedule/mode) in the modal — the table stays about "who".
export function SelectionActionBar({ count, subtext, onView, onClear, onCreate }: Props) {
  if (count <= 0) return null;

  return (
    <div className={styles.actionBar}>
      <div className={styles.actionBarCount}>
        <b>{count.toLocaleString()}</b> recipient{count === 1 ? "" : "s"} selected{" "}
        <span className={styles.actionBarSub}>{subtext}</span>
      </div>
      <div className={styles.actionBarActions}>
        {onView && (
          <Button variant="outlined" color="primary" size="small" onClick={onView}>
            View selected
          </Button>
        )}
        <Button variant="outlined" color="primary" size="small" onClick={onClear}>
          Clear
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          endIcon={<Icon icon="chevron-right" size="small" />}
          onClick={onCreate}
        >
          Create send
        </Button>
      </div>
    </div>
  );
}
